import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region ../icons/dist/react/default/seek.js
const SeekIcon = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M9 1a7.98 7.98 0 0 1 6.132 2.867l1.441-1.44a.25.25 0 0 1 .427.177V6.75a.25.25 0 0 1-.25.25h-4.146a.25.25 0 0 1-.177-.427L13.71 5.29A5.99 5.99 0 0 0 9 3a6 6 0 0 0-4.242 10.242l-1.415 1.415A8 8 0 0 1 9 1" })
});
const ForwardRef = forwardRef(SeekIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=seek.js.map